import React, { useEffect, useState } from "react";
import Dashboard from "../layouts/Dashboard";
import axios from "../services/axios";
import ReactLoading from "react-loading";
import { Pagination, Card } from "antd"; // Added Card here
import { DatePicker, Button } from "antd";
import moment from "moment";
import exportFromJSON from "export-from-json";
import { configConsumerProps } from "antd/lib/config-provider";
import { SearchOutlined } from "@ant-design/icons";
import { message } from "antd";
import dumpRights from "../services/dumpRights";
import isConsultant from "../services/isConsultant";
import { checkPermission } from "../utils/checkPermission";
import useRole from "../hooks/useRole";

const { RangePicker } = DatePicker;

//disable date logic -{Lovejot- 23-08-2022}
const disabledDate = (current) => {
  // 90 DAYS GAP AND DISABLE TOMORROW

  return (
    current.isBefore(moment().subtract(90, "day")) ||
    current > moment().endOf("day")
  );
};

const InterviewLogs = (props) => {
  const [defaultDate, setDefaultDate] = useState([]);
  const [current, setCurrent] = useState(1);
  const [csvData, setCsvData] = useState();
  const [load, setLoad] = useState(false);
  const [totalcandidate, setTotalCandidate] = useState(0);
  const [logs, setLogs] = useState([]);
  const [formData, setFormData] = useState([]);
  const [formId, setFormId] = useState("");
  const [buttonDisable, setButtonDisable] = useState(false);

  const [canViewInterviewLogs, setCanViewInterviewLogs] = useState(false);
  const [canDownloadInterviewLogs, setCanDownloadInterviewLogs] = useState(false);
  const userRole = useRole();

  const checkPermissions = async () => {
    try {
      const viewAllowed = await checkPermission(
        userRole,
        "interview_logs_module",
        "view_interview_logs"
      );
      const downloadAllowed = await checkPermission(
        userRole,
        "interview_logs_module",
        "download_interview_logs"
      );
      setCanViewInterviewLogs(viewAllowed);
      setCanDownloadInterviewLogs(downloadAllowed);
    } catch (err) {
      console.error("Error checking interview logs permissions:", err);
    }
  };

  useEffect(() => {
    checkPermissions();
  }, [userRole]);

  let startDate = defaultDate[0];
  let endDate = defaultDate[1];

  useEffect(() => {
    // if (window.location.href === "https://dh.maxicus.com/logs/interview") {
    //   if (dumpRights(localStorage.getItem("user.id")) === false) {
    //     setButtonDisable(true);
    //   }
    // }
    // if (window.location.href === "https://dhuat.maxicus.com/logs/interview") {
    //   if (dumpRights(localStorage.getItem("user.id")) === false) {
    //     setButtonDisable(true);
    //   }
    // }

    if (formId) {
      // loadLogs();
      loadCSV();
    } else {
      setLogs([]);
      setTotalCandidate(0);
    }
    loadFormData();
  }, [current, formId]);

  const loadLogs = () => {
    setLoad(true);
    axios
      .get(
        `/interviews/Dump/InterviewLogs?StartDate=${
          defaultDate[0]
            ? defaultDate[0]
            : moment(new Date()).format("YYYY-MM-DD")
        }&EndDate=${
          defaultDate[1]
            ? defaultDate[1]
            : moment(new Date()).format("YYYY-MM-DD")
        }&page=${
          current ? current : 1
        }&limit=10&formId=${formId}&userId=${localStorage.getItem("user.id")}`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("user.token")}`,
          },
        }
      )
      .then((res) => {
        setLogs(res.data.interviewLogs.data);
        setTotalCandidate(res.data.interviewLogs.dataCount);
        if (res.data.interviewLogs.data) {
          setLoad(false);
        }
      })
      .catch((err) => {
        console.log(err);
        setLoad(false);
      });
  };

  const loadCSV = () => {
    setLoad(true);
    axios
      .get(
        `/interviews/Dump/InterviewLogsDump?StartDate=${
          defaultDate[0]
            ? defaultDate[0]
            : moment(new Date()).format("YYYY-MM-DD")
        }&EndDate=${
          defaultDate[1]
            ? defaultDate[1]
            : moment(new Date()).format("YYYY-MM-DD")
        }&formId=${formId}&userId=${localStorage.getItem("user.id")}`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("user.token")}`,
          },
        }
      )
      .then((res) => {
        setCsvData(res.data.interviewLogs);
        setLoad(false);
      })
      .catch((err) => {
        console.log(err);
        setLoad(false);
      });
  };

  const loadFormData = () => {
    axios
      .get("/formtemplate", {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("user.token")}`,
        },
      })
      .then((res) => {
        const data = res.data;
        setFormData(data);
      });
  };

  const handlePagination = (page) => {
    setCurrent(page);
  };

  //DATE FILTER
  const handleDate = (value, dateString) => {
    if (value === null) {
      setCurrent(1);
      setFormId("");
      setLogs([]);
      setTotalCandidate(0);
      setDefaultDate([
        moment(new Date()).format("YYYY-MM-DD"),
        moment(new Date()).format("YYYY-MM-DD"),
      ]);
    } else {
      setCurrent(1);
      setFormId("");
      setDefaultDate(dateString);
    }
  };

  const onOk = (value) => {
    // console.log("onOk:", value);
  };

  //CSV DATA
  const exportType = "csv";
  const data = csvData;
  let fileName = `Interview_Logs_${moment(new Date()).format(
    "DD-MM-YYYY_HH:mm"
  )}`;
  const downloadCSV = () => {
    if (formId) {
      setCurrent(1);
      exportFromJSON({ data, fileName, exportType });
    } else {
      //console.log("error")
      message.warning("Please select the Form Type!", 2);
    }
  };

  const handleSelectFormType = (e) => {
    setFormId(e.target.value);
  };

  const searchHandle = (e) => {
    e.preventDefault();
    if (formId) {
      setCurrent(1);
      loadLogs();
      loadCSV();
    } else {
      //console.log("error")
      message.warning("Please select the Form Type!", 2);
    }
  };
  return (
    <div>
      {!isConsultant() && (
        <Dashboard title="Interview Logs">
          {load && (
            <ReactLoading type="spin" color="#0000FF" className="spinnerBg" />
          )}
          {canViewInterviewLogs ? (
            <div className="row p-3 border mb-2 bg-white cursor-pointer">
              <RangePicker
                format="YYYY-MM-DD"
                defaultValue={[moment(), moment()]}
                onChange={handleDate}
                onOk={onOk}
                disabledDate={disabledDate}
                placeholder={[
                  moment(new Date()).format("YYYY-MM-DD"),
                  moment(new Date()).format("YYYY-MM-DD"),
                ]}
              />
              <div className="col-md-2">
                <select
                  id="FormType"
                  className="mb-2 form-control"
                  onChange={handleSelectFormType}
                  value={formId}
                >
                  <option value="" selected="true">
                    Form Type
                  </option>
                  {formData &&
                    formData
                      .filter((ele) => {
                        return ele?.formType !== "Document_Form";
                      })
                      .map((obj) => {
                        return (
                          <option
                            //selected
                            value={obj._id}
                          >
                            {obj.name}
                          </option>
                        );
                      })}
                </select>
              </div>
              {canDownloadInterviewLogs && (
                <div className="col-md-2">
                  <button
                    className="btn btn-primary btn-block"
                    disabled={buttonDisable}
                    onClick={downloadCSV}
                  >
                    Download CSV
                  </button>
                </div>
              )}
            </div>
          ) : (
            !load && <Card className="p-3">You are not authorized to view this report.</Card>
          )}

          {/* <div className="card-body row p-3 border mb-4 bg-white cursor-pointer logs">
 <div className="table-responsive">
 {logs.length !== 0 ? (
 <table className="table bg-white ">
 <thead>
 <tr>
 <th className="table-column-head">Form Name</th>
 <th className="table-column-head">Candidate Name</th>
 <th className="table-column-head">Mobile No</th>
 <th className="table-column-head">Call Status1</th>
 <th className="table-column-head">Call Status2</th>
 <th className="table-column-head">Call Status3</th>
 <th className="table-column-head">InterView Status</th>
 <th className="table-column-head">Call Arrange Date</th>
 <th className="table-column-head">InterView Arrange Date</th>
 <th className="table-column-head">InterView Attempt Date</th>
 <th className="table-column-head">InterViewer Owner</th>
 <th className="table-column-head">InterViewer Name</th>
 <th className="table-column-head">Interview Type</th>
 <th className="table-column-head">Source</th>
 <th className="table-column-head">Preferred Location</th>
 </tr>
 </thead>
 <tbody>
 {logs.length > 0 &&
 logs.map((ele, i) => {
 return (
 <tr key={i}>
 <td className="table-column-head">
 {ele["Form Name"]}
 </td>
 <td className="table-column-head">
 {ele["Candidate Name"]}
 </td>
 <td className="table-column-head">
 {ele["Mobile No"]}
 </td>
 <td className="table-column-head">
 {ele["Call Status1"]}
 </td>
 <td className="table-column-head">
 {ele["Call Status2"]}
 </td>
 <td className="table-column-head">
 {ele["Call Status3"]}
 </td>
 <td className="table-column-head">
 {ele["InterView Status"]}
 </td>
 <td className="table-column-head">
 {ele["Call Arrange Date"]}
 </td>
 <td className="table-column-head">
 {ele["InterView Arrange Date"]}
 </td>
 <td className="table-column-head">
 {ele["InterView Attempt Date"]}
 </td>

 <td className="table-column-head">
 {ele["InterViewer Owner"]}
 </td>
 <td className="table-column-head">
 {ele["InterViewer Name"]}
 </td>
 <td className="table-column-head">
 {ele["Interview Type"]}
 </td>
 <td className="table-column-head">{ele.Source}</td>
 <td className="table-column-head">
 {ele["Preferred Location"]}
 </td>
 </tr>
 );
 })}
 </tbody>
 </table>
 ) : (
 <h3 style={{ fontWeight: 400 }}>No Data Available</h3>
 )}
 </div>
 <Pagination
 current={current}
 onChange={handlePagination}
 total={totalcandidate}
 showSizeChanger={false}
 className="mt-2"
 />
 </div> */}
        </Dashboard>
      )}
    </div>
  );
};

export default InterviewLogs;
